import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import { IconChevronRight } from '@tabler/icons';
import { FormattedMessage } from 'react-intl';
import MainCard from 'ui-component/cards/MainCard';

const BrandTitle = ({ title, menuTitle, colors, Icon }) => {
  const currentURLPath = window.location.pathname;

  return (
    <>
      <Breadcrumbs
        parentBreadcrumb={{
          title: <FormattedMessage id={menuTitle} />,
          type: 'collapse',
          url: '/',
          breadcrumbs: true,
        }}
        currentBreadcrumb={{
          title: title,
          url: currentURLPath,
          type: 'item',
          breadcrumbs: true,
        }}
        separator={IconChevronRight} icon title rightAlign
      />
      <MainCard sx={{ bgcolor: colors[0], color: '#fff' }}>
        <Icon />
        <h1 style={{ display: 'inline-block', paddingLeft: '0.5em' }}>{menuTitle}</h1>
      </MainCard>
    </>
  );
}

export default BrandTitle;